"use strict";exports.__esModule=true;exports.default=void 0;var _default={"initial.canvas.canvas":function initialCanvasCanvas(){return{"rect.appearing":function rectAppearing(){return[{initialAttr:{opacity:0},finalAttr:{opacity:1},slot:"initial"}]},"*":null}},"update.canvas.canvas":{"rect.updating":[{slot:"middle"}]}};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/charts/src/_internal/components/canvases/canvas.animation.js
// module id = UUBa
// module chunks = 5